"use strict";
exports.__esModule = true;
exports.AGENCIES = void 0;
exports.AGENCIES = [
    'Paris',

];
